export interface TerminateCorporateAdminDto {
  terminationDate: string; // Required, DateOnly as ISO string (YYYY-MM-DD)
  reason: string; // Required, max 500
  isRehireEligible?: boolean; // Default: false
}
